var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.62 12.33a4.54 4.54 0 100-9.08 4.54 4.54 0 000 9.08zM18.557 16.078a8.29 8.29 0 00-14.224 5.783.795.795 0 00.794.794H20.11a.795.795 0 00.795-.794 8.001 8.001 0 00-.385-2.482 8.23 8.23 0 00-1.963-3.3z",
    fill: "#2355FC"
  })));
}

export default SvgProfile;